export default __webpack_public_path__ + "static/media/delete.1b4d8d1a.svg";